<template>
  <div>
    <div class="layout-with-centered-max-width-child">
      <div>
        <div>
          <div class="banner">
            <div class="text">
              <h1>WELCOME TO BIMILEAP!</h1>
            </div>
          </div>
          <div class="sub-banner">
            <div class="text">
              <p>{{plugText}}</p>
            </div>
          </div>
          <div class="random-panel-header">
            <span>OUR STUDIES:</span>
          </div>
          <div class="overall-loading-container">
            <div v-if="loadingStarted">
              <loading></loading>
            </div>
            <div v-else-if="loadingSuccessful">
              <div>
                <div class="study-container">
                  <div class="each-study" v-for="study in studies" :key="study.id" >
                    <div v-on:click="loadSurvey(study)" class="study-card">
                      <div class="row-separation">
                        <span class="heading font-secondary">{{study.name}}</span>
                      </div>
                      <div class="row-separation">
                        <span>{{date(study.dateCreated)}}</span>
                      </div>
                      <div class="row-separation">
                        <span class="study-purpose rich-text-editor-custom-css" v-html="study.studyPurpose" />
                      </div>
                      <div class="row-separation">
                        <span class="tags">{{formatTags(study.tags)}}</span>
                      </div>
                      <div class="row-separation">
                        <span>{{status(study)}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else-if="loadingFailed">
              <div class="error-message">
                <span class="font-secondary">Unfortunately, we are having trouble loading example surveys</span>
                <div v-on:click="loadDifferentStudies" class="more-studies-button-error">
                  <span class="see-more-study">Try Again</span>
                  <Fai :icon="['fas', 'sync-alt']"/>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="more-studies">
              <div v-on:click="loadDifferentStudies" class="more-studies-button">
                <span class="see-more-study">See More Studies</span>
                <Fai :icon="['fas', 'sync-alt']"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {
    GET_BACKEND_URL,
    LOADING_COMPLETED_FAILURE,
    LOADING_COMPLETED_SUCCESS,
    LOADING_STARTED,
    STATIC_TEXT_PLUG_1,
  } from '../services/constants'
  import http from "../services/axios"
  import {formatDate} from "../services/utilities"

  export default {
    name: 'Home',

    data(){
      return{
        loadingStatus: LOADING_STARTED,
        studies: [],
      }
    },

    computed: {
      plugText() {
        return STATIC_TEXT_PLUG_1
      },
      loadingStarted(){
        return this.loadingStatus === LOADING_STARTED
      },
      loadingSuccessful(){
        return this.loadingStatus === LOADING_COMPLETED_SUCCESS
      },
      loadingFailed(){
        return this.loadingStatus === LOADING_COMPLETED_FAILURE
      },
    },

    created() {
      this.loadDifferentStudies()
    },
    methods:{
      date(date){
        date = new Date(date)
        return formatDate(date)
      },
      status(study){
        let closed = study.closed
        let maxParticipantsReaches = study.maxParticipantsReached
        let status = closed || maxParticipantsReaches ? 'Closed' : 'Open'
        return `Status: ${status}`
      },
      loadDifferentStudies(){
        this.loadingStatus = LOADING_STARTED
        http.get(this.$store.getters[GET_BACKEND_URL](`studies/browse?order=RANDOM`)).then(response => {
          this.studies = response.data.studySummaries
          this.loadingStatus = LOADING_COMPLETED_SUCCESS
        })
          .catch(err => {
            console.log(err)
            this.loadingStatus = LOADING_COMPLETED_FAILURE
          })
      },
      formatTags(tags){
        return tags.split(",").join(", ")
      },
      loadSurvey(study){
        this.$router.push(`study/${study.id}`)
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "../scss/main";

  .banner {
    height: 341px;
    background-image: url("../assets/images/homepage-image.jpg");
    display: flex;
    justify-content: center;
    align-items: center;

    .text {
      text-align: center;
    }
  }

  .text {
    color: $white-1;
  }

  .sub-banner {
    background-color: $cyan-blue-3;
    display: flex;
    justify-content: center;

    .text {
      max-width: 500px;
      width: 100%;
      padding: 1em 2em;
    }

  }

  .random-panel-header{
    padding: 5% 0;
    text-align: center;
    font-size: 20px;
  }

  .study-container{
    display: flex;
    flex-direction: row;
    @media #{$mobile} {
      flex-direction: column;
    }
    min-height: 300px;
  }

  .each-study{
    padding: 0 3%;
    @media #{$mobile} {
      padding: 1em 2em;
    }
    flex-basis: 25%;
    overflow-x: auto;
  }

  .study-purpose{
    font-size: 16px;
  }

  .heading{
    color: $red-2;
    font-weight: bold;
    font-size: 18px;
  }

  .row-separation{
    padding: 2.5% 0;
  }

  .tags{
    color: $gray-3;
    font-size: 16px;
  }

  .more-studies{
    padding: 0 0 4% 0;
  }

  .study-card{
    cursor: pointer;
  }

  .more-studies-button{
    text-align: center;
    text-decoration: underline;
    font-style: italic;
    cursor: pointer;
  }

  .see-more-study{
    padding-right: 5px;
  }

  .error-message{
    padding: 1% 0 8%;
    text-align: center;
    color: $red-2;
  }

  .more-studies-button-error{
    padding: 3% 0;
    text-decoration: underline;
    font-style: italic;
    cursor: pointer;
  }

  .overall-loading-container{
    min-height: 300px;
  }

</style>
